import { RemoteSignInViaImpersonate } from 'data/usecases';
import { SignInViaImpersonateUseCaseInterface } from 'domain/usecases';
import { makeApiUrlSignInViaImpersonate } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteSignInViaImpersonate =
  (): SignInViaImpersonateUseCaseInterface => {
    return new RemoteSignInViaImpersonate(
      makeApiUrlSignInViaImpersonate(),
      makeAxiosHttpClient(),
    );
  };
